import { contactEntry } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">投稿合作</h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8">{contactEntry.subtitle}</p>

          <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
            {contactEntry.tips.map((tip) => (
              <span
                key={tip}
                className="inline-block px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium whitespace-nowrap"
              >
                {tip}
              </span>
            ))}
          </div>

          <div className="inline-flex items-center gap-3 px-6 py-4 rounded-xl bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
              <i className="ri-mail-line text-primary-600 text-lg"></i>
            </span>
            <span className="text-foreground-800 font-medium text-sm md:text-base">{contactEntry.email}</span>
          </div>
        </div>
      </div>
    </section>
  );
}